import { get } from 'lodash';
import { PATIENT_ROOT_KEY, BOOKING_CONTAINER_ROOT_KEY } from '../../constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import insuranceNotTakenRequirementSelector from '../../selectors/InsuranceNotTakenRequirementSelector';
import { getDoctorCardProps } from '../../utils';

const mapStateToProps = (state = {}) => {
    const bookingState = bookingStateSelector(state);
    const referralId = get(bookingState, 'referral_id');

    return {
        ...state[PATIENT_ROOT_KEY],
        insuranceNotTakenRequirement:
            insuranceNotTakenRequirementSelector(state),
        ...getDoctorCardProps(state),
        referralId,
        bookingState,
        modalIsShowing: state[BOOKING_CONTAINER_ROOT_KEY].showModal,
    };
};

export default mapStateToProps;
